import { useEffect } from "react";
import { Form, Col, Row, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import usePost from "../hooks/usePost";
import CustomInput from "./inputWidgets/CustomInput";
import { openConfirmNotification, openErrorNotification } from "../utils/toast";
import { normalizeEmailValue } from "../utils/normalizeFormEmails";

export const AdminInvitation = ({ setIsModalOpen, payload }) => {
  const [form] = Form.useForm();
  const postUrl = `${process.env.REACT_APP_API_URL}/api/accounts/invite/`;

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  const onFinish = (values) => {
    try {
      const modifiedValues = {
        ...values,
        Email: normalizeEmailValue(values.Email),
        HostLink: window.location.origin,
        ...payload, // Spread additional payload values here
      };

      postAction(modifiedValues);
    } catch (error) {
      openErrorNotification("Something went wrong. Please try again.");
      console.log(error);
    }
  };

  // Handle side effects like success or failure notifications
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong."
      );
    } else if (postData && !postLoading) {
      openConfirmNotification("Success");
      setIsModalOpen(false); // Close the modal on success
    }
  }, [postData, postError, postLoading, setIsModalOpen]);

  return (
    <div>
      <Form
        form={form}
        onFinish={onFinish}
        validateTrigger="onChange"
        layout="vertical"
        autoComplete="off"
        scrollToFirstError
      >
        <div className="bg-white rounded-[4px] overflow-hidden">
          <div className="px-2 pt-1 pb-3">
            <Row gutter={[16, 8]}>
              <Col span={24}>
                <CustomInput
                  label="Email"
                  name="Email"
                  type="email"
                  isEmail={true}
                  required
                />
              </Col>
            </Row>
          </div>

          {/* Submit and Cancel buttons */}
          <div className="flex justify-center space-x-2 mt-2.5">
            <Button
              type="primary"
              className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center"
              onClick={() => form.submit()}
              loading={postLoading}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              <span>Apply</span>
            </Button>

            <Button
              className="reset-button"
              onClick={() => setIsModalOpen(false)}
            >
              <CloseOutlined />
              <span>Cancel</span>
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};
